import React, { useCallback } from 'react';
import styled from 'styled-components';

const Styled = styled.div`
  width: 32px;
  height: 32px;
  cursor: pointer;
  background: ${p => p.color};
  border: 1px solid ${p => (p.isDark ? 'transparent' : '#d9d9d9')};
  border-radius: 2px;
`;

export function SelectableColor(props) {
    const { color, onChange, isDark } = props;

    const handleClick = useCallback(() => {
        onChange(color);
    }, [color, onChange]);

    return (
        <Styled color={color} onClick={handleClick} isDark={isDark} />
    );
}
